
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class MyCheckbox extends Vue {
  @Prop({ default: "", type: String })
  label: string;
  @Prop({ default: "", type: String })
  helpText: string;
}
